import {all, select, put, takeLatest} from 'redux-saga/effects';
import {SET_CURRENT_OFFERS} from 'Container/OfferDisplay/constant';
import {
    selectDefaultOfferIds,
    selectOffers,
    selectUserHasInternet,
    selectUserHasMobilfunk,
    selectUserHasNone,
    selectUserHasTV,
    selectUserWantsInternet,
    selectUserWantsMobilfunk,
    selectUserWantsRedplus,
    selectUserWantsTV,
} from 'Container/Landingpage/selector';
import {setCurrentOfferSuccess} from 'Container/OfferDisplay/action';
import { IOfferFromJSON } from 'app/types';
import { generateOfferId, getOffers, IOfferKeyElements } from 'Container/Landingpage/helpers/offerDataHelper';

/**
 * retrieves all Offers from jarvis
 */
export function* setCurrentOffersFromJSON () {

    const [has_mobilfunk, has_internet, has_tv, has_none, wants_mobilfunk, wants_internet, wants_tv, wants_redplus, offers, defaultOfferIds] =
        yield all([
            select(selectUserHasMobilfunk()),
            select(selectUserHasInternet()),
            select(selectUserHasTV()),
            select(selectUserHasNone()),
            select(selectUserWantsMobilfunk()),
            select(selectUserWantsInternet()),
            select(selectUserWantsTV()),
            select(selectUserWantsRedplus()),
            select(selectOffers()),
            select(selectDefaultOfferIds()),
        ]);

    const offerIdElements: IOfferKeyElements = {
        has_mobilfunk,
        has_internet,
        has_tv,
        has_none,
        wants_mobilfunk,
        wants_internet,
        wants_tv,
        wants_redplus,
    };

    // Init
    let currentOffers: IOfferFromJSON[];
    let isDefault = false;

    const offerId = generateOfferId(offerIdElements);
    currentOffers = getOffers([offerId], offers);

    let defaultOffers = [];

    if ('' !== defaultOfferIds.trim()) {
        defaultOffers = getOffers(defaultOfferIds.split(',').map(item => item.trim()), offers);
    }

    if (0 === currentOffers.length) {
        isDefault = true;
        currentOffers = defaultOffers;
    }

    yield put(setCurrentOfferSuccess(currentOffers, isDefault));

}

/**
 * Waits for GET_OFFERS action to call getAPI
 *
 * @export {function} offersSaga
 */
export default function* offerDisplaySaga () {
    yield takeLatest(SET_CURRENT_OFFERS, setCurrentOffersFromJSON);
}
